// hogan.js populates `exports` when a CommonJS environment is present (as it is
// under esbuild), so it won't self-attach to window. Expose the global.
import Hogan from "../vendor/hogan.js"

window.Hogan = Hogan

export default Hogan
